import { createReducer, on } from '@ngrx/store';
import { Event, PageData } from '../../models';
import * as pageActions from '../actions/events.action';
import * as utility from '../../../utility';

export interface EventsState {
  entities: { [id: number]: Event };
  overview: { [id: number]: Event };
  loaded: boolean;
  loading: boolean;
  overviewLoaded: boolean;
  overviewLoading: boolean;
  error?: any;
  page: PageData;
}

export const initialState: EventsState = {
  entities: {},
  overview: {},
  loaded: false,
  loading: false,
  overviewLoaded: false,
  overviewLoading: false,
  page: { current: 0, pageCount: 0, resultCount: 0, size: 12 },
};

export const EventsReducer = createReducer(
  initialState,
  on(pageActions.LoadEvents, (state: EventsState) => {
    return {
      ...state,
      loading: true,
    };
  }),
  on(pageActions.LoadEventsSuccess, (state: EventsState, { events }) => {
    const entities = utility.ToEntities(events.items, 'id', {});
    return {
      ...state,
      entities,
      loading: false,
      loaded: true,
    };
  }),
  on(pageActions.LoadEventsFail, (state: EventsState, { error }) => {
    return {
      ...state,
      loading: false,
      loaded: false,
      error,
    };
  }),
  on(pageActions.LoadEventsOverview, (state: EventsState) => {
    return {
      ...state,
      overviewLoading: true,
    };
  }),
  on(pageActions.LoadEventsOverviewSuccess, (state: EventsState, { events }) => {
    const overview = utility.ToEntities(events.items, 'id', {});
    return {
      ...state,
      overview,
      page: events.page,
      overviewLoading: false,
      overviewLoaded: true,
    };
  }),
  on(pageActions.LoadEventsOverviewFail, (state: EventsState, { error }) => {
    return {
      ...state,
      overviewLoading: false,
      overviewLoaded: false,
      error,
    };
  }),
  on(pageActions.LoadEventDetail, (state: EventsState, { id }) => {
    const overview = { ...state.overview, [id]: { ...state.overview[id], loaded: false, loading: true } };
    return {
      ...state,
      overview,
    };
  }),
  on(pageActions.LoadEventDetailSuccess, (state: EventsState, { event }) => {
    const overview = {
      ...state.overview,
      [event.id]: { ...event, loaded: true },
    };

    return {
      ...state,
      overview,
    };
  }),
  on(pageActions.ResetEvents, (state: EventsState) => {
    return {
      ...state,
      overview: {},
      overviewLoaded: false,
      overviewLoading: false,
    };
  })
);

export const getEventsEntities = (state: EventsState) => state.entities;
export const getEventsLoading = (state: EventsState) => state.loading;
export const getEventsLoaded = (state: EventsState) => state.loaded;

export const getEventsOverviewEntities = (state: EventsState) => state.overview;
export const getEventsOverviewLoading = (state: EventsState) => state.overviewLoading;
export const getEventsOverviewLoaded = (state: EventsState) => state.overviewLoaded;
